const state = {
};

const getters = {
};

const actions = {
    LoadLogSettings({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('logs.get_settings', {
                domain_id: request_data['domain_id'],
            });

            this._vm.$axios.get(r)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.logs_settings);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    PostLogSettings({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('logs.post_settings', {
                domain_id: request_data['domain_id'],
            });

            this._vm.$axios.post(r, {
                configuration: request_data['configuration'],
                logging_config: request_data['logging_config']
            })
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },
};

const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
